import FormConnect from './form/Connect'
import FormPage from './form/Page'
import WhatsappConnect from './whatsapp/Connect'
import WhatsappPage from './whatsapp/Page'

/*
CUSTOM_UI
conectores exóticos (auth.type === 'custom'), com modal de conexão e página de
configuração dedicados. a chave é o auth.ui devolvido pela integração.
*/
const CUSTOM_UI = {
  whatsapp: {
    connect: WhatsappConnect,
    page: WhatsappPage
  }
}

/*
FORM_UI
conector genérico: monta o formulário a partir do schema da integração
(auth.formSchema para conectar, settings.formSchema para editar).
*/
const FORM_UI = {
  connect: FormConnect,
  page: FormPage
}

export default {
  /*
  getConnector
  resolve o par connect/page a partir da integração
  */
  getConnector (integration) {
    const auth = (integration && integration.auth) || {}
    if (auth.type === 'custom' && CUSTOM_UI[auth.ui]) return CUSTOM_UI[auth.ui]
    return FORM_UI
  }
}



// WEBPACK FOOTER //
// ./src/components/Integrations/connectors/index.js